import { memo } from 'react'
import { Button, List, ListItem, ListItemIcon, styled } from '@mui/material'
import { PersonOutline } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { drawerVar } from '../../../../../providers/apollo/cache'

const AccountList = styled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  '.MuiListItem-root': {
    padding: 0
  },
  '.MuiButton-root': {
    gap: '8px',
    padding: '0 8px',
    color: '#727C8C',
    fontSize: '0.875rem',
    fontWeight: 500,
    '.MuiListItemIcon-root': {
      minWidth: 0,
      color: '#727C8C',
      '.MuiSvgIcon-root': {
        maxWidth: '20px'
      }
    },
    '&:hover': {
      background: 'transparent',
      color: theme.palette.primary.main,
      '.MuiListItemIcon-root': {
        color: theme.palette.primary.main
      }
    }
  }
}))

function AccountMenu() {
  const navigate = useNavigate()

  const handleAccountNavigation = () => {
    navigate('/settings#profile')
    drawerVar(null)
  }

  return (
    <AccountList>
      <ListItem>
        <Button onClick={handleAccountNavigation}>
          <ListItemIcon>
            <PersonOutline />
          </ListItemIcon>
          My Account
        </Button>
      </ListItem>
    </AccountList>
  )
}

export default memo(AccountMenu)
